import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const GoogleAdsGuide = () => {
  const relatedBlogs = [
    {
      id: 1,
      title: 'How to Optimize Your Medical Practice Website for Local SEO in 2026',
      image: '/images/Blog4.png',
      date: 'February 3, 2026'
    },
    {
      id: 2,
      title: 'Top 10 Social Media Marketing Strategies for Doctors in 2026',
      image: '/images/Blog2.png',
      date: 'January 28, 2026'
    },
    {
      id: 4,
      title: 'Patient Acquisition Through Digital Marketing: A Complete Guide',
      image: '/images/Blog4.png',
      date: 'January 15, 2026'
    }
  ];

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-4 sm:px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8"
          >
            Google Ads for Healthcare Providers
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Home
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <Link 
              to="/blog" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Blog
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
              Google Ads Guide
            </span>
          </motion.div>
        </div>
      </section>

      {/* SECTION 1: TWO-COLUMN WITH SIDEBAR */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <div className="grid lg:grid-cols-12 gap-6 lg:gap-8">
            
            {/* LEFT SIDE - Intro Content */}
            <div className="lg:col-span-8">
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="mb-8"
              >
                <img 
                  src='/images/Blog6.png'
                  alt="Google Ads for Healthcare"
                  className="w-full rounded-2xl"
                />
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#19354a] mb-6"
              >
                The Complete Guide to Google Ads for Healthcare Providers
              </motion.h1>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="flex flex-wrap items-center gap-4 text-sm text-[#19354a] mb-8 pb-6 border-b-2 border-gray-200"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                  </svg>
                  <span>Docmize Team</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Published : January 20, 2026</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Last Updated : January 20, 2026</span>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  Google Ads represents one of the most powerful patient acquisition tools available to healthcare providers in 2026. With patients increasingly starting their healthcare journeys with online searches, strategic Google Ads campaigns position your practice at the top of search results precisely when potential patients need your services. Unlike organic SEO that takes months to build, Google Ads delivers immediate visibility, making it essential for practices seeking rapid growth and patient acquisition.
                </p>

                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  This comprehensive guide covers everything healthcare providers need to know about creating, managing, and optimizing Google Ads campaigns. From understanding healthcare advertising policies and keyword research to campaign structure, ad compliance, and performance tracking, we'll explore proven strategies that help medical practices generate high-quality patient leads while maximizing return on ad spend.
                </p>
              </motion.div>

            </div>

            {/* RIGHT SIDE - Sidebar */}
            <motion.aside 
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="lg:col-span-4"
            >
              <div className="sticky top-24">
                
                <div className="bg-white rounded-2xl border-2 border-[#19354a] p-6 mb-6">
                  <h3 className="text-xl font-bold text-[#19354a] mb-6 pb-4 border-b-2 border-gray-200">
                    Categories
                  </h3>
                  <div className="space-y-2">
                    {['Web Development', 'SEO', 'Social Media', 'Web Design', 'Online Reputation Management', 'Digital Marketing', 'Video Marketing', 'Paid Advertising', 'App Development'].map((category, index) => (
                      <Link
                        key={index}
                        to="/blog"
                        className="w-full text-left px-4 py-3 rounded-lg font-medium transition-all bg-gray-50 text-gray-700 hover:bg-[#19354a] hover:text-white block"
                      >
                        <div className="flex items-center justify-between">
                          <span>{category}</span>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#19354a] to-[#0f2133] rounded-2xl p-6 text-white">
                  <h3 className="text-xl font-bold mb-4">
                    Need Google Ads Help?
                  </h3>
                  <p className="text-white/80 mb-6 text-sm leading-relaxed">
                    Get expert Google Ads management tailored for healthcare practices.
                  </p>
                  <Link 
                    to="/contact"
                    className="block w-full text-center px-6 py-3 bg-[#39a5d3] text-white rounded-lg font-semibold hover:bg-white hover:text-[#19354a] transition-all"
                  >
                    Get Free Consultation
                  </Link>
                </div>

              </div>
            </motion.aside>

          </div>
        </div>
      </section>

      {/* SECTION 2: FULL WIDTH CONTENT */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Understanding Google Ads for Healthcare
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Google Ads operates on a pay-per-click model where advertisers bid on keywords relevant to their services. When patients search for those keywords, your ads appear at the top of search results marked as "Sponsored." You only pay when someone clicks your ad, making it a cost-effective patient acquisition channel when properly managed. For healthcare providers, this means appearing exactly when patients actively search for medical services, capturing high-intent leads ready to book appointments.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Healthcare advertising through Google requires strict adherence to policies governing medical services, prescription medications, and health-related content. Google prohibits certain healthcare advertising practices while requiring certification for others. Understanding these policies prevents account suspension and ensures your campaigns reach patients effectively. Successful healthcare Google Ads campaigns balance aggressive patient acquisition with policy compliance and ethical marketing practices.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Healthcare Advertising Policy Compliance
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Google maintains specific policies for healthcare and medicines advertising to protect users from misleading health claims and unqualified providers. Advertisers must obtain Google certification for certain healthcare categories including prescription drugs, online pharmacies, addiction services, and clinical trials. General healthcare services like primary care, dentistry, and most specialties don't require certification but must comply with general advertising policies prohibiting false claims and requiring appropriate licensing.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Review Google's healthcare advertising policies thoroughly before launching campaigns. Avoid making unverifiable health claims, promising specific outcomes, or using before-and-after images without proper disclaimers. Ensure landing pages clearly display practice credentials, licensing information, and contact details. Include appropriate disclaimers about medical advice and individual results varying. Policy violations can result in ad disapproval or account suspension, making compliance essential for sustainable Google Ads success.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Comprehensive Keyword Research Strategy
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Effective keyword research forms the foundation of successful healthcare Google Ads campaigns. Start by identifying services you want to promote, then research how patients search for those services. Use Google's Keyword Planner to discover search volumes, competition levels, and suggested bid ranges for healthcare-related keywords. Focus on high-intent keywords indicating patient readiness to book appointments—terms like "urgent care near me," "dentist accepting new patients," or "[specialty] doctor in [city]."
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Organize keywords into tightly themed ad groups based on services, conditions, or procedures. Include branded keywords protecting your practice name from competitors. Add location-based keywords for local targeting. Consider patient intent—informational searches ("symptoms of [condition]") versus transactional searches ("schedule [procedure] appointment"). Match types control how broadly your ads show: broad match reaches more searches, phrase match balances reach and relevance, while exact match targets specific searches with highest intent. Strategic keyword selection maximizes ROI while controlling advertising costs.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Campaign Structure and Organization
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Proper campaign structure improves performance tracking, optimization, and budget management. Create separate campaigns for different services, locations, or marketing objectives. Within each campaign, organize ad groups by specific themes with 10-20 closely related keywords per group. This structure allows precise control over budgets, bids, and messaging. For multi-location practices, create location-specific campaigns enabling targeted budget allocation and performance comparison across offices.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Use campaign-level settings to control geographic targeting, ad scheduling, and budget allocation. Set appropriate daily budgets based on expected cost-per-click and desired patient volume. Implement ad scheduling to show ads during office hours or when staff can handle appointment requests. Add negative keywords at campaign or account level preventing irrelevant searches from triggering ads. Well-organized campaigns simplify management while providing granular performance insights guiding optimization decisions.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Writing Compelling Ad Copy
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Effective healthcare ad copy balances professionalism with persuasive messaging that resonates with patient concerns. Headlines should include target keywords while highlighting unique value propositions—specialized expertise, convenient locations, insurance acceptance, or appointment availability. Use responsive search ads that automatically test different headline and description combinations, identifying top-performing variations. Include specific calls-to-action like "Book Your Appointment Today" or "Schedule Free Consultation."
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Leverage ad extensions expanding ad real estate while providing additional information. Sitelink extensions direct patients to specific service pages. Call extensions enable direct phone calls from search results. Location extensions show practice addresses and map locations. Structured snippets highlight service categories or accepted insurance. Review extensions showcase patient testimonials and ratings. Ad extensions improve click-through rates while providing patients multiple ways to engage with your practice, increasing conversion opportunities.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Landing Page Optimization
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Landing pages significantly impact campaign performance and patient conversion rates. Create dedicated landing pages aligned with ad messaging and keywords. Each page should focus on a single service or condition with clear information about treatment options, benefits, and next steps. Include prominent call-to-action buttons for appointment scheduling. Display credentials, certifications, and patient reviews building trust. Ensure pages load quickly, display correctly on mobile devices, and comply with healthcare advertising guidelines.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Implement conversion tracking measuring appointment requests, form submissions, and phone calls generated by campaigns. Use clear, simple forms requesting essential information without overwhelming potential patients. Include multiple contact options—online booking, phone numbers, and contact forms—accommodating different patient preferences. Test landing page variations improving conversion rates over time. Strong landing pages transform ad clicks into patient appointments, maximizing return on ad spend while providing excellent user experience.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Bid Management and Budget Optimization
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Strategic bid management balances cost control with competitive positioning. Start with manual bidding to understand keyword performance and cost-per-click ranges. Monitor Quality Score—Google's rating of ad relevance, landing page experience, and expected click-through rate. Higher Quality Scores reduce costs while improving ad positions. Gradually transition to automated bidding strategies like Target CPA (cost-per-acquisition) or Maximize Conversions once sufficient conversion data accumulates.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Allocate budgets based on service profitability and patient lifetime value. High-value services justify higher cost-per-acquisition. Set bid adjustments for devices, locations, and time of day based on performance data. Increase bids during peak search times when patients actively seek appointments. Monitor competitor activity and adjust bids maintaining visibility against aggressive competitors. Regular bid optimization ensures maximum patient acquisition within budget constraints while preventing overspending on underperforming keywords.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Performance Tracking and Analytics
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Comprehensive tracking enables data-driven optimization improving campaign performance over time. Link Google Ads with Google Analytics tracking complete patient journeys from initial ad clicks through appointment bookings. Implement call tracking measuring phone inquiries generated by campaigns. Set up conversion actions for online appointment requests, contact form submissions, and other valuable patient interactions. Track cost per conversion, conversion rates, and return on ad spend identifying profitable campaigns and optimization opportunities.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Review performance metrics regularly including impressions, clicks, click-through rates, conversion rates, and cost per acquisition. Identify high-performing keywords deserving increased investment. Pause or optimize underperforming keywords draining budget without generating appointments. Analyze search term reports discovering new keyword opportunities and adding negative keywords preventing irrelevant clicks. Continuous monitoring and optimization separate successful campaigns from wasteful ad spending, ensuring your Google Ads investment generates sustainable patient growth.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Advanced Campaign Strategies
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Advanced strategies amplify Google Ads effectiveness for sophisticated healthcare marketers. Implement remarketing campaigns targeting website visitors who didn't schedule appointments, keeping your practice top-of-mind as they continue their healthcare search. Use audience targeting reaching patients based on demographics, interests, or life events relevant to your services. Create customer match campaigns uploading patient email lists (with proper consent) for targeted messaging to existing patients about new services or health maintenance reminders.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Test responsive display ads expanding reach beyond search results to websites, YouTube, and Gmail. Experiment with video campaigns on YouTube educating potential patients about procedures and practice philosophy. Implement local service ads for eligible providers appearing in Google's Local Services section with prominent placement and Google Guaranteed badge. Advanced strategies diversify patient acquisition channels while leveraging Google's extensive advertising network beyond traditional search campaigns.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Compliance and Ethical Considerations
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Healthcare Google Ads require strict attention to medical ethics and advertising regulations beyond Google's policies. Ensure all advertising claims are truthful, verifiable, and don't mislead patients about treatment outcomes. Avoid creating unrealistic expectations or guaranteeing specific medical results. Comply with state medical board advertising regulations governing healthcare marketing. Maintain patient privacy by never using patient information in advertising without explicit consent. Include appropriate disclaimers about individual results varying and advertising not substituting medical consultations.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Consider competitive advertising ethics—bidding on competitor names requires careful consideration of legal and ethical implications. Focus advertising on your practice's unique value propositions rather than disparaging competitors. Maintain professional tone and messaging reflecting your practice values. Your Google Ads campaigns should enhance your professional reputation while attracting patients, never compromising medical ethics or patient trust for short-term advertising gains. Ethical, compliant advertising builds sustainable practice growth while maintaining professional integrity.
            </p>

            {/* FAQ SECTION */}
            <div className="mt-12 mb-12">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-8 text-center">
                Frequently Asked Questions (FAQs)
              </h2>

              <div className="space-y-4">
                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How much should healthcare providers spend on Google Ads?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Google Ads budgets vary based on specialty, location, and competition. Most practices start with $2,000-$5,000 monthly budgets, adjusting based on performance. High-value specialties like dentistry or plastic surgery may justify larger investments. Calculate acceptable cost per patient acquisition based on service profitability and patient lifetime value. Start conservatively, then scale successful campaigns as you demonstrate positive ROI.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      What's the average cost-per-click for healthcare keywords?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Healthcare cost-per-click varies significantly by specialty and location. Primary care might range $3-$10 per click, while competitive specialties like cosmetic dentistry or plastic surgery can exceed $50-$100 per click. Local market competition heavily influences pricing. Use Google Keyword Planner for specific keyword cost estimates in your area before committing budgets.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How long does it take to see results from Google Ads?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Google Ads delivers immediate visibility—your ads can appear within hours of campaign launch. However, optimal performance requires 2-3 months of data collection and optimization. Initial campaigns test keywords, ad copy, and landing pages. As conversion data accumulates, automated bidding strategies improve performance. Expect consistent results within 90 days of continuous optimization and refinement.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      Should I hire an agency or manage Google Ads in-house?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Healthcare-specialized agencies bring industry expertise, policy knowledge, and proven optimization strategies. They're ideal for practices lacking Growth Ecosystem experience or staff bandwidth. In-house management works for smaller budgets or practices with dedicated marketing personnel. Consider hybrid approaches—agencies for strategy and complex campaigns, in-house for day-to-day management. Evaluate costs versus expected performance improvements when making decisions.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How can Docmize help with Google Ads management?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Docmize specializes in healthcare Google Ads with proven expertise in medical advertising compliance, keyword research, campaign optimization, and conversion tracking. We handle complete campaign management including strategy development, ad creation, bid management, landing page optimization, and performance reporting. Our healthcare focus ensures campaigns comply with regulations while maximizing patient acquisition and ROI.
                  </div>
                </details>
              </div>
            </div>

          </motion.div>
        </div>
      </section>

      {/* RELATED BLOGS SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl font-bold text-[#19354a] mb-8"
          >
            Related Blog
          </motion.h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {relatedBlogs.map((blog, index) => (
              <motion.article
                key={blog.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#19354a] mb-3 line-clamp-2">
                    {blog.title}
                  </h3>
                  <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                    <span>{blog.date}</span>
                  </div>
                  <Link 
                    to={`/blog/${blog.id}`}
                    className="inline-flex items-center gap-2 text-[#39a5d3] font-semibold hover:gap-3 transition-all"
                  >
                    Read More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GoogleAdsGuide;